// WhatsAppButton.js
import React from "react";


const WhatsAppButton = () => {
    const phoneNumber = "8527203697"; // Replace with your WhatsApp number
    const message = "Hello, I have a query regarding Account Management/Digital Marketing/Product Listings, etc."; // Optional pre-filled message

    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition duration-300"
            aria-label="Chat on WhatsApp"
        >
            <ion-icon name="logo-whatsapp" size="large"></ion-icon>
        </a>

    );
};

export default WhatsAppButton;
